import React, { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

// Register necessary components with Chart.js
ChartJS.register(ArcElement, Tooltip, Legend, Title, ChartDataLabels);
export default function Reportstats(props) {
  const [labels, setLabels] = useState([]);
  const [values, setValues] = useState([]);

  useEffect(() => {
    if (props.item.ctrl_type_name === "MULTI") {
      const multiItemsdata = props.data.filter(
        (item) => item.surv_ques_label === props.item.surv_ques_label
      );
      setLabels(multiItemsdata.map((item) => item.input_val));
      setValues(multiItemsdata.map((item) => item.rec_count));
    }
  }, [props.data]);

  const data = {
    labels: labels, //["Hypospadias", "Blue", "Yellow", "Green", "Purple", "Orange"],
    datasets: [
      {
        label: "# of Cases",
        data: values, //[12, 19, 3, 5, 2, 15],
        backgroundColor: [
          "rgba(255, 99, 132, 0.2)",
          "rgba(54, 162, 235, 0.2)",
          "rgba(255, 206, 86, 0.2)",
          "rgba(75, 192, 192, 0.2)",
          "rgba(153, 102, 255, 0.2)",
          "rgba(255, 159, 64, 0.2)",
          "rgba(255, 114, 132, 0.2)",
          "rgba(54, 102, 235, 0.2)",
          "rgba(255, 154, 86, 0.2)",
          "rgba(75, 109, 192, 0.2)",
          "rgba(153, 97, 255, 0.2)",
          "rgba(255, 78, 64, 0.2)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
          "rgba(255, 114, 132, 0.2)",
          "rgba(54, 102, 235, 0.2)",
          "rgba(255, 154, 86, 0.2)",
          "rgba(75, 109, 192, 0.2)",
          "rgba(153, 97, 255, 0.2)",
          "rgba(255, 78, 64, 0.2)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      tooltip: {
        enabled: true,
      },
      /*datalabels: {
        color: "#000",
        anchor: "end",
        align: "start",
        offset: -10,
        borderWidth: 1,
        borderColor: "#000",
        borderRadius: 25,
        backgroundColor: (context) => context.dataset.backgroundColor,
        font: {
          //weight: "bold",
          size: 12,
        },
        formatter: (value, context) => {
          return `${context.chart.data.labels[context.dataIndex]}: ${value}`;
        },
      },*/
      datalabels: {
        color: "#000",
        anchor: "end",
        align: "start",
        formatter: (value) => value, // Display the value of each segment
      },
    },
  };

  return (
    <>
      {props.item.ctrl_type_name === "TEXT" && (
        <div className="col-xl-6 col-lg-6">
          <div className="card shadow mb-4" style={{ height: 330 }}>
            <div className="card-header-light">
              {props.item.surv_ques_label}
            </div>
            <div className="card-body">Count: {props.item.rec_count}</div>
          </div>
        </div>
      )}
      {props.item.ctrl_type_name === "NUMBER" && (
        <div className="col-xl-6 col-lg-6">
          <div className="card shadow mb-4" style={{ height: 330 }}>
            <div className="card-header-light">
              {props.item.surv_ques_label}
            </div>
            <div className="card-body">
              <table>
                <tr>
                  <td>Count:</td>
                  <td>{props.item.rec_count}</td>
                </tr>
                {/*<tr>
                  <td>Mean:</td>
                  <td>{props.item.rec_mean}</td>
                </tr>
                <tr>
                  <td>Median:</td>
                  <td>{props.item.rec_median}</td>
                </tr>
                <tr>
                  <td>Mode:</td>
                  <td>{props.item.rec_mode}</td>
                </tr>
                <tr>
                  <td>Std. Dv:</td>
                  <td>{props.item.rec_std_dev}</td>
                </tr>*/}
              </table>
            </div>
          </div>
        </div>
      )}
      {props.item.ctrl_type_name === "MULTI" && (
        <div className="col-xl-6 col-lg-6">
          <div className="card shadow mb-4" style={{ height: 330 }}>
            <div className="card-header-light">
              {props.item.surv_ques_label}
            </div>
            <div className="card-body">
              <Doughnut data={data} options={options} />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
